class BrandclubStoreConfigUtils {
    static getAppStage() {
        var _a;
        const nodeEnv = ((_a = import.meta.env) === null || _a === void 0 ? void 0 : _a.MODE) || process.env.NODE_ENV;
        if (nodeEnv === 'development') {
            return 'localhost';
        }
        const origin = window.location.origin;
        if (origin.includes('beta.brandclub') || origin.includes('-beta.') || origin.includes('beta-')) {
            return 'beta';
        }
        if (origin.includes('gamma.brandclub') || origin.includes('-gamma.') || origin.includes('gamma-')) {
            return 'gamma';
        }
        return 'prod';
    }
    static getWebAppId() {
        return window.location.hostname;
    }
    /**
     * @param parentScriptName - The name of the script that is hosting the common-ui.
     * @returns The origin of the script that is hosting the common-ui.
     */
    static getScriptOrigin(parentScriptName) {
        const currentScript = document.currentScript;
        if (currentScript === null || currentScript === void 0 ? void 0 : currentScript.src) {
            return new URL(currentScript.src).hostname;
        }
        if (!parentScriptName) {
            return null;
        }
        // Fallback: Find the script by its distinctive path
        const findScript = () => {
            const scripts = Array.from(document.querySelectorAll('script[src]'));
            for (const script of scripts) {
                if (script.src.includes(parentScriptName)) {
                    return script;
                }
            }
            return null;
        };
        const script = findScript();
        if (script === null || script === void 0 ? void 0 : script.src) {
            try {
                return new URL(script.src).hostname; // Will return "shop.abc.com"
            }
            catch (_a) {
                return null;
            }
        }
        return null;
    }
    static getLocalStorageDomain(appStage = 'prod', { domainName, }) {
        if (this.storageDomain) {
            return this.storageDomain;
        }
        const hostname = window.location.hostname.toLowerCase();
        if (hostname.includes('brandclub.com')) {
            // For brandclub domains, use stage prefix (except prod or gamma)
            this.storageDomain = appStage === 'prod' ? 'brandclub.com' : `${appStage}.brandclub.com`;
        }
        else {
            // For third-party domains, prefer script origin (where checkout app is hosted) or hostname
            const scriptOrigin = domainName !== null && domainName !== void 0 ? domainName : this.getScriptOrigin();
            this.storageDomain = scriptOrigin || (hostname.startsWith('shop.') ? hostname : 'shop.' + hostname);
        }
        return this.storageDomain;
    }
    static getCookieDomain() {
        if (this.cookieDomain) {
            return this.cookieDomain;
        }
        const hostname = window.location.hostname.toLowerCase();
        // Split the hostname and get the parts
        const parts = hostname.split('.');
        // If we have less than 2 parts, return the whole hostname
        if (parts.length < 2) {
            this.cookieDomain = hostname;
            return hostname;
        }
        // Extract base domain, handling multi-part TLDs
        const tld = parts[parts.length - 1];
        let cookieDomain;
        if (tld.length === 2 && parts.length >= 3) {
            // Country code TLD, likely has structure like .co.in, .com.au
            cookieDomain = parts.slice(-3).join('.');
        }
        else {
            // Generic TLD (.com, .org, .net, etc.) - take last 2 parts
            cookieDomain = parts.slice(-2).join('.');
        }
        this.cookieDomain = cookieDomain;
        return cookieDomain;
    }
    static getApiHostName() {
        return `${window.location.origin}/api-rewards`;
    }
    static getServerSideSyncHostName() {
        return `${window.location.origin}/api-retailer-sync`;
    }
    static getGoogleMapsApiKey() {
        return 'AIzaSyDIvKiFNOD6JC_3ZXMeE4rtPVw49BFanJg';
    }
    static getGoogleMapsMapId() {
        return '6b6881fc70e2cb88'; // Created in google cloud console
    }
    static getEdgeCachedApiHostName() {
        return `${window.location.origin}/api-rewards`;
    }
    static getGraphQlUri() {
        const base = this.getApiHostName();
        return `${base}/graphql`;
    }
    static getStripePublishableKey() {
        const appStage = this.getAppStage();
        if (appStage === 'localhost' && this.stripeDebugMode) {
            return 'pk_test_51LnQyZJrInA7nkEZROUUcHyEsSs2CP3eWlIzOzIk6eMyGIKF8vsjZ4cGFjxrjZas6FlwTs2F9YvxrGsbdwojbxRO00IBijaZzD';
        }
        return 'pk_live_51LnQyZJrInA7nkEZJwYqka6fFt6Zz8m1V3l4hC2Rn3N3iLXCWgd8K3oQonZw3SWdpZoZ1UPogaw3kQwt5DyWnVXz00Mr9PFmjh';
    }
    static getServerSideSyncGraphQlUri() {
        const base = this.getServerSideSyncHostName();
        return `${base}/graphql`;
    }
}
BrandclubStoreConfigUtils.stripeDebugMode = false;
BrandclubStoreConfigUtils.cookieDomain = "";
BrandclubStoreConfigUtils.storageDomain = "";

export { BrandclubStoreConfigUtils as default };
//# sourceMappingURL=brandclubStoreConfigUtils.js.map
